import {post} from '../utils/request'

export default {
    isLogin() {
        return post("/admin/isLogin", {});
    },
    login(username, password) {
        return post("/admin/login", {username, password});
    }
}
